import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Container, Navbar, Nav, DropdownButton, Dropdown } from 'react-bootstrap'
import { useSelector } from "react-redux";
import { logout, userStore } from "../../../redux/reduxStore.js";
import { IconMenu3, IconUserStar, IconHome2, IconReportSearch, IconBriefcase2, IconUserSearch, IconMessagePlus, IconSettings, IconPasswordUser, IconLogout, IconCaretDownFilled } from '@tabler/icons-react';

const AdminHeader = () => {
  const Admin = useSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname || "userprofile");
  const handleLogout = () => {
    userStore.dispatch(logout());
    navigate("/");
  }

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleHashChange = () => {
    setActiveLink(location.pathname);
  };

  useEffect(() => {
    handleHashChange();
  }, [location]);

  const handleToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  return (
    <>
      <Navbar expand="xl" id="header" className='admin-header' ref={menuRef} expanded={isMenuOpen}>
        <Container fluid>
          <Link to="/dashboard" className="navbar-brand"><img src="../Images/myfx-logo-new.png" alt="" /></Link>
          <div className="d-xl-none d-flex align-items-center gap-3">
            <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle}><IconMenu3 size={40} stroke={2} /></Navbar.Toggle>
            <Link className={`${activeLink === "Adminprofile" || activeLink === "/adminprofile" ? 'active' : ''}`} to="/adminprofile">
            <IconUserStar color="#FFA300" size={30} stroke={1} />
            </Link>
          </div>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto me-xl-5">
              <Link className={`nav-link ${activeLink === "dashboard" || activeLink === "/dashboard" || activeLink == "/" ? 'active' : ''}`} to="/dashboard">
                <IconHome2 size={24} stroke={2} /> Dashboard
              </Link>
              <Link className={`nav-link ${activeLink === "quotations" || activeLink === "/quotations" ? 'active' : ''}`} to="/quotations">
                <IconReportSearch size={24} stroke={2} /> Quotations
              </Link>
              <Link className={`nav-link ${activeLink === "orders" || activeLink === "/orders" ? 'active' : ''}`} to="/orders">
                <IconBriefcase2 size={24} stroke={2} /> Orders
              </Link>
              <Link className={`nav-link ${activeLink === "/users" || activeLink == "users" || activeLink === "/userprofile" ? 'active' : ''}`} to="/users">
                <IconUserSearch size={24} stroke={2} /> Users
              </Link>
              <Link className={`nav-link ${activeLink === "admintestimonial" || activeLink === "/admintestimonial" ? 'active' : ''}`} to="/admintestimonial">
                <IconMessagePlus size={24} stroke={2} /> Testimonial
              </Link>
              <Link className={`nav-link ${activeLink === "controlpanel" || activeLink === "/controlpanel" ? 'active' : ''}`} to="/controlpanel">
                <IconSettings size={24} stroke={2} /> Control panel
              </Link>

              <Link className={`nav-link d-flex d-xl-none ${activeLink === "changepassword" || activeLink === "/changepassword" ? 'active' : ''}`} to="/changepassword">
                <IconPasswordUser size={24} stroke={2} /> Change password
              </Link>

              <Link className="nav-link d-flex d-xl-none" onClick={() => handleLogout()} to="/home">
                <IconLogout size={24} stroke={2} /> Logout
              </Link>
            </Nav>
            <div className="user-bar">
              <DropdownButton autoClose id="dropdown-basic-button" align="end"
                title={
                  <div className='userinfo'>
                    <div className="left">
                      <IconUserStar size={24} stroke={2} />
                      <span>{Admin.userName}</span>
                    </div>
                    <div className="right">
                      <IconCaretDownFilled size={18} stroke={2} />
                    </div>
                  </div>
                }>
                <Link to="/adminprofile" className={`dropdown-item ${activeLink === "Adminprofile" || activeLink === "/adminprofile" ? 'active' : ''}`}>My profile</Link>
                <Link to="/changepassword" className={`dropdown-item ${activeLink === "Changepassword" || activeLink === "/changepassword" ? 'active' : ''}`}>Change password</Link>
                <Dropdown.Divider />
                <button onClick={() => handleLogout()} className="dropdown-item">Logout</button>
              </DropdownButton>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  )
}

export default AdminHeader;